import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateCompaniesApp = document.createElement('template');

templateCompaniesApp.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <header class='page__header'>
      <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>

  <div class='wrapper'>
    <div class='companies-content'>
      <gz-companies-grid></gz-companies-grid>
    </div>
  </div>

  <div id="grid-side-panel-wrapper"></div>
`;
